export const reassuranceBlock = `
_type == 'reassuranceBlock' => {
  image {
    crop,
    image-> {
      _type,
      _id,
      path,
      dimensions
    }
  },
}
`
